import React, { useEffect, useRef, useState, useMemo } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Link, useNavigate } from "react-router-dom";
import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { Modal, ModalHeader, ModalBody } from "reactstrap";
import { Autoplay, Navigation } from "swiper/modules";
import { useDispatch, useSelector } from "react-redux";
import { Baseurl } from "../../config/BaseUrl";
import axios from "axios";
import { toast } from "react-toastify";
import { pageStatusChange } from "../../redux/property/PropertySlice";
import PropertyDetailsModel from "./latestProperty/PropertyDetailsModel";
import { sortPropertiesWithImagesFirst } from "../../utils/propertyUtils";
import { toggleShortlistProperty, isPropertyShortlisted } from "../../utils/shortlistUtils";
import { setModelShow } from "../../redux/athentication/Athentication";
import "./TopPropertiesNew.css";

/* Crisp Vector Icons matching Reference Image */
const BedIcon = () => (
  <svg width="19" height="19" viewBox="0 0 24 24" fill="none" stroke="#b87a14" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <path d="M2 9v11" />
    <path d="M22 20v-7a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v7" />
    <path d="M2 15h20" />
    <path d="M6 11V7a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v4" />
  </svg>
);

const BathIcon = () => (
  <svg width="19" height="19" viewBox="0 0 24 24" fill="none" stroke="#b87a14" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <path d="M4 12h16a1 1 0 0 1 1 1v3a4 4 0 0 1-4 4H7a4 4 0 0 1-4-4v-3a1 1 0 0 1 1-1Z" />
    <path d="M6 12V5a2 2 0 0 1 2-2h1a2 2 0 0 1 2 2v2" />
    <path d="M5 19l-1.5 2" />
    <path d="M19 19l1.5 2" />
  </svg>
);

const AreaIcon = () => (
  <svg width="19" height="19" viewBox="0 0 24 24" fill="none" stroke="#b87a14" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <rect x="3" y="3" width="18" height="18" rx="2" />
    <path d="M3 9h18" strokeDasharray="2 2" />
    <path d="M3 15h18" strokeDasharray="2 2" />
    <path d="M9 3v18" strokeDasharray="2 2" />
    <path d="M15 3v18" strokeDasharray="2 2" />
  </svg>
);

const PhoneIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor">
    <path d="M20.01 15.38c-1.23 0-2.42-.2-3.53-.56a.977.977 0 0 0-1.01.24l-2.2 2.2a15.053 15.053 0 0 1-6.59-6.59l2.2-2.21a.96.96 0 0 0 .25-1A11.36 11.36 0 0 1 8.57 3.99c.07-.55-.38-1-1-1H4.11c-.59 0-1.07.46-1.1 1.05C2.66 12.89 11.1 21.34 20.05 21c.59-.03 1.05-.51 1.05-1.1v-3.52c0-.55-.45-1-1-.99l-.09-.01z"/>
  </svg>
);

const ChatIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z" />
    <circle cx="8.5" cy="12" r="0.75" fill="currentColor" />
    <circle cx="12" cy="12" r="0.75" fill="currentColor" />
    <circle cx="15.5" cy="12" r="0.75" fill="currentColor" />
  </svg>
);

const HeartIcon = ({ isFavorite }) => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill={isFavorite ? "#e11d48" : "none"} stroke={isFavorite ? "#e11d48" : "#1f2937"} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" />
  </svg>
);

const MapPinIcon = () => (
  <svg width="12" height="12" viewBox="0 0 24 24" fill="currentColor">
    <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5z"/>
  </svg>
);

const CameraIcon = () => (
  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z" />
    <circle cx="12" cy="13" r="4" />
  </svg>
);

const PrevArrowIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="15 18 9 12 15 6" />
  </svg>
);

const NextArrowIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="9 18 15 12 9 6" />
  </svg>
);

// Fallback Top Properties matching exact reference image with rich, accurate specifications
const FALLBACK_TOP_PROPERTIES = [
  {
    propertyID: "top-aparna-1",
    apartment: "Aparna Serene Park",
    apartmentName: "Aparna Serene Park",
    category: "Sell",
    subCategory: "Flat/apartment",
    superCategory: "Residential",
    visiblePrice: "2.3 Cr",
    expectedPrice: "23000000",
    locality: "Kondapur",
    city: "Hyderabad",
    noofBedrooms: 3,
    noofBathrooms: 3,
    carpetArea: "1750",
    carpetAreaMesurmentType: "sq.ft.",
    postUserPosition: "Dealer",
    DeskImg: ["https://res.cloudinary.com/dctspi0kc/image/upload/v1730458274/Property/DesktopImage/u91d5pb7agltq9mxdvyg.webp"],
    unicProperty: "This 3 BHK Flat/apartment is available for Sell in Aparna Serene Park, Kondapur, one of the most prominent gated communities in Hyderabad.",
  },
  {
    propertyID: "top-bhooja-2",
    apartment: "MY HOME BHOOJA",
    apartmentName: "MY HOME BHOOJA",
    category: "Sell",
    subCategory: "Flat/apartment",
    superCategory: "Residential",
    visiblePrice: "9.0 Cr",
    expectedPrice: "90000000",
    locality: "HITEC City",
    city: "Hyderabad",
    noofBedrooms: 3,
    noofBathrooms: 4,
    carpetArea: "3430",
    carpetAreaMesurmentType: "sq.ft.",
    postUserPosition: "Dealer",
    DeskImg: ["https://res.cloudinary.com/dctspi0kc/image/upload/v1730458675/Property/DesktopImage/k5dxbixawbjumpalbhll.webp"],
    unicProperty: "This 3 BHK Luxury Flat is available for Sell in MY HOME BHOOJA, HITEC City, offering panoramic skyline views and ultra-modern amenities.",
  },
  {
    propertyID: "top-vessella-3",
    apartment: "Vessella Woods",
    apartmentName: "Vessella Woods",
    category: "Sell",
    subCategory: "Villa",
    superCategory: "Residential",
    visiblePrice: "8.0 Cr",
    expectedPrice: "80000000",
    locality: "Kondapur",
    city: "Hyderabad",
    noofBedrooms: 4,
    noofBathrooms: 4,
    carpetArea: "3950",
    carpetAreaMesurmentType: "sq.ft.",
    postUserPosition: "Owner",
    DeskImg: ["https://res.cloudinary.com/dctspi0kc/image/upload/v1730458750/Property/DesktopImage/zrwkrgdryvwbzv2ug9lm.webp"],
    unicProperty: "This 4 BHK Luxury Villa is available for Sell in Vessella Woods, Kondapur, featuring private landscaped garden, duplex layout and premium finishes.",
  },
];

const BoostedProperty = () => {
  const { isAuth, loginData } = useSelector((store) => store.Athentication);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [boostProperties, setBoostProperties] = useState([]);
  const [bycity] = useState("Hyderabad");
  const [modal, setModal] = useState(false);
  const [singleProperty, setSingleProperty] = useState(null);
  const [actionType, setActionType] = useState("contact");
  const [favorites, setFavorites] = useState({});

  const swiperRef = useRef(null);

  const toggle = () => setModal(!modal);

  useEffect(() => {
    let isMounted = true;
    const fetchdata = async () => {
      try {
        const url = `${Baseurl}/api/v1/property/boostedpropertybycity/${bycity}`;
        const fetchProperty = await axios.get(url);
        if (isMounted && fetchProperty.data?.success === true) {
          const searchresult = fetchProperty.data.propertybycity || [];
          setBoostProperties(sortPropertiesWithImagesFirst(searchresult));
        }
      } catch (error) {
        // Fallback is handled automatically in useMemo
      }
    };

    fetchdata();
    return () => {
      isMounted = false;
    };
  }, [bycity]);

  const toggleClick = (e, property, type = "contact") => {
    if (e && e.preventDefault) e.preventDefault();
    setSingleProperty(property);
    setActionType(type || "contact");
    setModal(true);
  };

  const verifyLogin = () => {
    dispatch(setModelShow(true));
    toast.info("Please log in to contact dealer or view phone number.", {
      position: "top-center",
      autoClose: 2000,
      className: "custom_toast",
    });
  };

  const handleActionClick = (e, property, type = "contact") => {
    if (e && e.preventDefault) e.preventDefault();

    if (isAuth) {
      if (loginData && (loginData.creadits >= 1 || loginData.credits >= 1 || !loginData.hasOwnProperty("creadits"))) {
        toggleClick(e, property, type);
      } else {
        navigate("/dashboard");
        dispatch(pageStatusChange(9));
      }
    } else {
      verifyLogin();
    }
  };

  const handleFavoriteClick = (e, propId, propObj) => {
    e.preventDefault();
    e.stopPropagation();
    const targetProp = propObj || { _id: propId, propertyID: propId };
    const isAdded = toggleShortlistProperty(targetProp);
    setFavorites((prev) => ({ ...prev, [propId]: isAdded }));
    if (isAdded) {
      toast.success("Property saved to shortlist!", {
        position: "top-center",
        autoClose: 1500,
      });
    } else {
      toast.info("Removed from shortlist", {
        position: "top-center",
        autoClose: 1500,
      });
    }
  };

  // Sort properties to match reference image order:
  // 1. Aparna Serene Park
  // 2. MY HOME BHOOJA
  // 3. Vessella Woods
  const sortedProperties = useMemo(() => {
    let list = boostProperties && boostProperties.length > 0 ? [...boostProperties] : [...FALLBACK_TOP_PROPERTIES];

    const getScore = (p) => {
      const title = `${p.apartment || p.apartmentName || ""} ${p.unicProperty || ""}`.toLowerCase();
      if (title.includes("aparna serene")) return 1;
      if (title.includes("my home bhooja") || title.includes("bhooja")) return 2;
      if (title.includes("vessella woods") || title.includes("vessella")) return 3;
      return 100;
    };

    return list.sort((a, b) => getScore(a) - getScore(b));
  }, [boostProperties]);

  useEffect(() => {
    const syncFavorites = () => {
      const newFavs = {};
      (sortedProperties || []).forEach((p) => {
        const id = p.propertyID || p._id;
        if (id) {
          newFavs[id] = isPropertyShortlisted(p);
        }
      });
      setFavorites(newFavs);
    };
    syncFavorites();
    window.addEventListener("mgh_shortlist_updated", syncFavorites);
    return () => window.removeEventListener("mgh_shortlist_updated", syncFavorites);
  }, [sortedProperties]);

  const getImageSrc = (property) => {
    if (!property) return "/assets/images/why_choose_villa.jpg";

    if (Array.isArray(property.DeskImg) && property.DeskImg.length > 0 && property.DeskImg[0]) {
      return property.DeskImg[0];
    }
    if (typeof property.DeskImg === "string" && property.DeskImg.trim()) {
      return property.DeskImg;
    }
    if (Array.isArray(property.photos) && property.photos.length > 0 && property.photos[0]) {
      return property.photos[0];
    }
    if (typeof property.photos === "string" && property.photos.trim()) {
      return property.photos;
    }
    if (Array.isArray(property.images) && property.images.length > 0 && property.images[0]) {
      return property.images[0];
    }
    if (typeof property.images === "string" && property.images.trim()) {
      return property.images;
    }
    if (Array.isArray(property.mobileimage) && property.mobileimage.length > 0 && property.mobileimage[0]) {
      return property.mobileimage[0];
    }
    if (typeof property.mobileimage === "string" && property.mobileimage.trim()) {
      return property.mobileimage;
    }
    if (property.thumbnail) return property.thumbnail;
    if (property.image) return property.image;
    if (property.img) return property.img;

    return "/assets/images/why_choose_villa.jpg";
  };

  const getTransactionBadge = (property) => {
    const cat = property.category || "";
    const lower = cat.toLowerCase();
    if (lower === "sell" || lower === "sale") return "Buy";
    if (lower === "rent") return "Rent";
    if (lower === "lease") return "Lease";
    if (lower === "pg") return "PG";
    return cat || "Buy";
  };

  const getTypeBadge = (property) => {
    return property.subCategory || property.superCategory || "Flat/apartment";
  };

  const getPhotoCount = (property) => {
    const count =
      (property.DeskImg && property.DeskImg.length) ||
      (property.photos && property.photos.length) ||
      (property.images && property.images.length) ||
      1;
    return `${count} Photos`;
  };

  const getLocationString = (property) => {
    const locality = property.locality || property.landMark;
    const apt = property.apartment || property.apartmentName;
    const city = property.city || property.state || "Hyderabad";

    const loc = locality || apt || "";
    if (loc && city) {
      if (loc.toLowerCase().includes(city.toLowerCase())) {
        return loc;
      }
      return `${loc}, ${city}`;
    }
    return loc || city || "Hyderabad";
  };

  const getAreaString = (property) => {
    if (property.carpetArea && property.carpetArea !== "undefined" && property.carpetArea !== "") {
      return `${property.carpetArea} ${property.carpetAreaMesurmentType || "sq.ft."}`;
    }
    if (property.superbuildupArea && property.superbuildupArea !== "undefined" && property.superbuildupArea !== "") {
      return `${property.superbuildupArea} ${property.superbuildupAreaMesurmentType || "sq.ft."}`;
    }
    if (property.plotArea && property.plotArea !== "undefined" && property.plotArea !== "") {
      return `${property.plotArea} ${property.plotAreaMesurmentType || "sq.yd."}`;
    }
    if (property.unicProperty) {
      const match = property.unicProperty.match(/Carpet Area of\s*([\d\w\s\.]+?)(?:,|\.|\s|$)/i);
      if (match && match[1] && match[1].trim() !== "sq" && match[1].trim().length > 2) {
        return match[1].trim();
      }
      const match2 = property.unicProperty.match(/(\d[\d,]*\s*(?:sq\.?\s*ft\.?|sqft|sq\.?\s*yd\.?|sqyd))/i);
      if (match2 && match2[1]) {
        return match2[1].trim();
      }
    }
    return "- Area";
  };

  const formatPrice = (val, property) => {
    const raw = val || property?.visiblePrice || property?.expectedPrice || property?.monthlyRent || property?.price;
    if (!raw) return "Price on Request";
    const str = String(raw).trim();
    if (str.startsWith("₹") || str.toLowerCase().startsWith("rs")) return str;

    const num = Number(str.replace(/[^0-9.]/g, ""));
    if (!isNaN(num) && num > 0 && !str.toLowerCase().includes("cr") && !str.toLowerCase().includes("l")) {
      if (num >= 10000000) {
        return `₹ ${(num / 10000000).toFixed(2).replace(/\.00$/, "")} Cr`;
      } else if (num >= 100000) {
        return `₹ ${(num / 100000).toFixed(2).replace(/\.00$/, "")} L`;
      } else if (num >= 1000) {
        return `₹ ${num.toLocaleString("en-IN")}`;
      }
    }
    return `₹ ${str}`;
  };

  const getDescription = (property) => {
    if (property.unicProperty && property.unicProperty.trim().length > 0) {
      return property.unicProperty;
    }
    const bhk = property.noofBedrooms ? `${property.noofBedrooms} BHK ` : (property.bhk ? `${property.bhk} BHK ` : "");
    const subCat = property.subCategory || property.superCategory || "Flat/apartment";
    const cat = property.category === "Sell" ? "Sale" : (property.category || "Sale");
    const apt = property.apartment || property.apartmentName || "prime project";
    const loc = property.locality ? `${property.locality}, ` : "";
    const city = property.city || "Hyderabad";
    const area = property.carpetArea
      ? `Constructed on a Carpet Area of ${property.carpetArea} ${property.carpetAreaMesurmentType || "sq.ft."}, the property offers modern living spaces.`
      : "Offering excellent connectivity and top-tier amenities.";
    return `This ${bhk}${subCat} is available for ${cat} in ${apt}, ${loc}${city}. ${area}`;
  };

  const getBhkText = (property) => {
    if (property.noofBedrooms !== undefined && property.noofBedrooms !== null && property.noofBedrooms !== "") {
      return `${property.noofBedrooms} BHK`;
    }
    if (property.bhk !== undefined && property.bhk !== null && property.bhk !== "") {
      return `${property.bhk} BHK`;
    }
    return "- BHK";
  };

  const getBathText = (property) => {
    if (property.noofBathrooms !== undefined && property.noofBathrooms !== null && property.noofBathrooms !== "") {
      return `${property.noofBathrooms} Bath`;
    }
    if (property.bathrooms !== undefined && property.bathrooms !== null && property.bathrooms !== "") {
      return `${property.bathrooms} Bath`;
    }
    return "- Bath";
  };

  return (
    <section className="top-prop-section">

      <div className="top-prop-inner">
        {/* Section Header */}
        <div className="top-prop-header">
          <div className="top-prop-header-left">
         
            <h2 className="top-prop-title">
              <span className="top-prop-title-dark">Top </span>
              <span className="top-prop-title-gold">Properties</span>
            </h2>
            <p className="top-prop-desc">
              Explore the most popular properties in Hyderabad. Find your perfect
              home, commercial space or investment opportunity.
            </p>
          </div>

          {/* Swiper Slider Navigation Buttons */}
          <div className="top-prop-nav-btns">
            <button
              type="button"
              className="top-prop-nav-btn"
              onClick={() => swiperRef.current?.slidePrev()}
              title="Previous"
            >
              <PrevArrowIcon />
            </button>
            <button
              type="button"
              className="top-prop-nav-btn"
              onClick={() => swiperRef.current?.slideNext()}
              title="Next"
            >
              <NextArrowIcon />
            </button>
          </div>
        </div>

        {/* Swiper Slider Container */}
        <div className="top-prop-swiper-wrap">
          <Swiper
            onBeforeInit={(swiper) => {
              swiperRef.current = swiper;
            }}
            slidesPerView={4}
            spaceBetween={16}
            grabCursor={true}
            observer={true}
            observeParents={true}
            loop={sortedProperties.length > 4}
            autoplay={{
              delay: 4000,
              disableOnInteraction: false,
              pauseOnMouseEnter: true,
            }}
            breakpoints={{
              0: {
                slidesPerView: 1.35,
                spaceBetween: 10,
              },
              380: {
                slidesPerView: 1.42,
                spaceBetween: 10,
              },
              480: {
                slidesPerView: 1.5,
                spaceBetween: 12,
              },
              768: {
                slidesPerView: 2.2,
                spaceBetween: 14,
              },
              1024: {
                slidesPerView: 4,
                spaceBetween: 16,
              },
            }}
            modules={[Autoplay, Navigation]}
            className="top-prop-swiper"
          >
            {sortedProperties.map((property, index) => {
              const propId = property.propertyID || property._id || `top-prop-${index}`;
              const propUrl = `/property-info/${property.apartment || property.propertyID || "property"}/${property.propertyID}`;

              return (
                <SwiperSlide key={propId}>
                  <article className="top-prop-card">
                    {/* Image Wrap */}
                    <div className="top-prop-img-wrap">
                      <Link to={propUrl} className="top-prop-img-link">
                        <img
                          src={getImageSrc(property)}
                          alt={property.apartment || property.apartmentName || "Property"}
                          className="top-prop-img"
                          loading="lazy"
                          onError={(e) => {
                            e.target.onerror = null;
                            e.target.src = "/assets/images/why_choose_villa.jpg";
                          }}
                        />
                      </Link>

                      {/* Top-Left Badges */}
                      <div className="top-prop-badges-left">
                        <span className="top-prop-badge-buy">
                          {getTransactionBadge(property)}
                        </span>
                        <span className="top-prop-badge-type">
                          {getTypeBadge(property)}
                        </span>
                      </div>

                      {/* Top-Right Favorite / Wishlist */}
                      <button
                        type="button"
                        className="top-prop-fav-btn"
                        onClick={(e) => handleFavoriteClick(e, propId, property)}
                        title="Add to Wishlist"
                      >
                        <HeartIcon isFavorite={!!favorites[propId]} />
                      </button>

                      {/* Bottom-Left Location Overlay */}
                      <div className="top-prop-location-badge">
                        <MapPinIcon />
                        <span>{getLocationString(property)}</span>
                      </div>

                      {/* Bottom-Right Photos Count Overlay */}
                      <div className="top-prop-photos-badge">
                        <CameraIcon />
                        <span>{getPhotoCount(property)}</span>
                      </div>
                    </div>

                    {/* Card Body */}
                    <div className="top-prop-card-body">
                      {/* Title */}
                      <Link to={propUrl} className="top-prop-card-title-link">
                        <h3 className="top-prop-card-title" title={property.apartment || property.apartmentName || "Featured Property"}>
                          {property.apartment || property.apartmentName || "Featured Property"}
                        </h3>
                      </Link>

                      {/* Price */}
                      <div className="top-prop-card-price">
                        {formatPrice(property.visiblePrice, property)}
                      </div>

                      {/* Description */}
                      <p className="top-prop-card-desc" title={getDescription(property)}>
                        {getDescription(property)}
                      </p>

                      {/* Specifications Row */}
                      <div className="top-prop-card-specs">
                        <div className="top-prop-spec-item" title="Bedrooms">
                          <span className="top-prop-spec-icon-wrap"><BedIcon /></span>
                          <span>{getBhkText(property)}</span>
                        </div>

                        <div className="top-prop-spec-item" title="Bathrooms">
                          <span className="top-prop-spec-icon-wrap"><BathIcon /></span>
                          <span>{getBathText(property)}</span>
                        </div>

                        <div className="top-prop-spec-item" title="Carpet Area">
                          <span className="top-prop-spec-icon-wrap"><AreaIcon /></span>
                          <span>{getAreaString(property)}</span>
                        </div>
                      </div>

                      {/* Action Buttons Row */}
                      <div className="top-prop-card-actions">
                        <button
                          type="button"
                          className="top-prop-btn-phone"
                          onClick={(e) => handleActionClick(e, property, "phone")}
                        >
                          <PhoneIcon />
                          <span className="top-prop-btn-lbl-full">View Phone</span>
                          <span className="top-prop-btn-lbl-mob">Call</span>
                        </button>

                        <button
                          type="button"
                          className="top-prop-btn-contact"
                          onClick={(e) => handleActionClick(e, property, "contact")}
                        >
                          <ChatIcon />
                          <span className="top-prop-btn-lbl-full">Contact {property.postUserPosition || "Dealer"}</span>
                          <span className="top-prop-btn-lbl-mob">Contact</span>
                        </button>
                      </div>
                    </div>
                  </article>
                </SwiperSlide>
              );
            })}
          </Swiper>
        </div>
      </div>

      {/* Details & Contact Modal */}
      {modal && singleProperty && (
        <Modal
          isOpen={modal}
          toggle={() => setModal(!modal)}
          className="modalmainnew"
          centered
        >
          <div className="model-wrappernew">
            {/* ModalHeader omitted to prevent duplicate X button */}
            <ModalBody style={{ padding: 0 }}>
              <PropertyDetailsModel
                closePropdet={() => setModal(false)}
                propertyprop={singleProperty}
                actionType={actionType}
                changeView={() => {}}
              />
            </ModalBody>
          </div>
        </Modal>
      )}
    </section>
  );
};

export default BoostedProperty;
